// extracted by mini-css-extract-plugin
module.exports = {"logo":"Login_logo__3R5vb","welcome":"Login_welcome__2_Oby","form":"Login_form__2mkKy","instructions":"Login_instructions__2evxz","error":"Login_error__15WaX"};